// extracted by mini-css-extract-plugin
module.exports = {"container":"results_container__29d1z","title":"results_title__2Thaw","content":"results_content__1_qLW"};